//
// # ViewPort
//
// Indication of the user-viewable coordinate range, or the lack thereof.
// Primarily used for culling, i.e. declining to draw stuff the user won't be able to see anyway.
//
// The infinite viewport is used in cases where we can't determine single viewport,
// e.g. the instanced drawing of multiply instantiated objects,
// each of which lies at a different position on the screen.
//
import { Bbox } from "GenAlphaModel";

type Finite = { kind: "finite"; bbox: Bbox };
type Infinite = { kind: "infinite" };

export type ViewPort = Finite | Infinite;
export const ViewPort = {
  finite(bbox: Bbox): Finite {
    return { kind: "finite", bbox };
  },
  infinite(): Infinite {
    return { kind: "infinite" };
  },
};
